import { useLocation } from 'react-router-dom'
import { useAppSelector } from '../../common/store'
import { getLaiskeyFromPath } from '../../common/util'
import { getFloodData } from './slice'

export function useFloodData() {
  const location = useLocation()
  const laisKey = getLaiskeyFromPath(location.pathname, true)
  const floodData = useAppSelector(getFloodData)
  return floodData?.laisKey === laisKey ? floodData : null
}

export const numberFormatter = new Intl.NumberFormat('en-AU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})